import { Component } from '@angular/core';
import { StateService } from '@app/core/services/state.service';

@Component({
    selector: 'tt-orderline-calc-form-view',
    templateUrl: './orderline-calc-form-view.component.html',
    styleUrls: ['./orderline-calc-form-view.component.css'],
})
export class OrderlineCalcFormViewComponent {
    params: any;

    constructor(private state: StateService) {
        this.params = state.getStateParams();
    }

    public onSubmit(event: any) {
        this.state.back();
    }
}
